import React from 'react'
import ButtonCustom from '../CustomButtom/ButtonCustom'
import { format } from 'date-fns'

export const TableDetails = ({ data, onClick}) => {
  return (
    <div className="table-responsive mt-1">
      <table className="table table-bordered table-striped" style={{fontSize: "small"}}>
        <thead className="thead-dark text-uppercase">
          <tr>
            <th>ESTADO</th>
            <th>ACCION</th>
            <th>DESCRIPCION</th>
            <th>USUARIO REGISTRO</th>
            <th>ARCHIVO</th>
            <th>FECHA CIERRE USUARIO</th>
            <th>FECHA REGISTRO</th>
          </tr>
        </thead>
        <tbody className="text-capitalize">
          {data.map((r) => (
            <tr key={r.id}>
              <td className="text-capitalize">{r.name}</td>
              <td className="text-capitalize">{r.accion}</td>
              <td className="text-lowercase">{r.description}</td>
              <td>
                {r.name_r} {r.last}
              </td>
              <td>
                {r.idfoldertype ? (
                  <ButtonCustom
                    type="button"
                    onClick={() => onClick(r.idfoldertype)}
                    classnames="btn btn-secondary btn-sm font-weight-bold"
                  >
                    <i className="fa fa-download"></i>
                  </ButtonCustom>
                ) : (
                  <></>
                )}
              </td>
              <td>{r.fecha_cierre}</td>
              <td>{format(new Date(r.created), "yyyy-MM-dd HH:mm:ss")}</td>
            </tr>
          ))}          
        </tbody>
      </table>
    </div>
  );
}
